import { Component } from '@angular/core';

import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-fullscreen-file-image-modal',
    templateUrl: 'fullscreen-file-image-modal.component.html',
    standalone: false
})
export class FullscreenFileImageModalComponent {
  public imageUrl: string;

  constructor(private modalCtrl: ModalController) {
  }

  public async closeModal() {
    await this.modalCtrl.dismiss();
  }
}
